var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 6.66667L14 7.22222L10.9126 9.36623C10.5836 9.59469 10.4192 9.70892 10.2404 9.75319C10.0825 9.7923 9.91748 9.7923 9.75958 9.75319C9.58085 9.70892 9.41635 9.59469 9.08737 9.36623L6 7.22222L5.2 6.66667M3.6 17.5H16.4C16.9601 17.5 17.2401 17.5 17.454 17.391C17.6422 17.2951 17.7951 17.1422 17.891 16.954C18 16.7401 18 16.4601 18 15.9V4.1C18 3.53995 18 3.25992 17.891 3.04601C17.7951 2.85785 17.6422 2.70487 17.454 2.60899C17.2401 2.5 16.9601 2.5 16.4 2.5H3.6C3.03995 2.5 2.75992 2.5 2.54601 2.60899C2.35785 2.70487 2.20487 2.85785 2.10899 3.04601C2 3.25992 2 3.53995 2 4.1V15.9C2 16.4601 2 16.7401 2.10899 16.954C2.20487 17.1422 2.35785 17.2951 2.54601 17.391C2.75992 17.5 3.03995 17.5 3.6 17.5Z",
    stroke: "#99A4B1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.6c630cd213feb1b27c6b60f8e3c17e01.svg";
export { ForwardRef as ReactComponent };